export default function () {

    const $cart      = jQuery('.wc__cart');
    if ( ! $cart.length ) return;

    const MIN_LOADING = 800; // ms — minimum time the loading state stays visible

    let qtyTimer;

    function getItem( key ) {
        return $cart.find('[data-cart-key="' + key + '"]');
    }

    function setLoading( key ) {
        getItem( key ).addClass('is-loading');
        $cart.find('.wc__cart-total').addClass('is-loading');
    }

    function clearLoading( key ) {
        getItem( key ).removeClass('is-loading');
        $cart.find('.wc__cart-total').removeClass('is-loading');
    }

    function refreshCart( data ) {
        $cart.find('.wc__cart-items').html( data.items_html );
        $cart.find('.wc__cart-total').replaceWith( data.totals_html );
    }

    function withMinDelay( start, fn ) {
        const elapsed   = Date.now() - start;
        const remaining = Math.max( 0, MIN_LOADING - elapsed );
        setTimeout( fn, remaining );
    }

    function updateItem( key, quantity ) {
        setLoading( key );
        const start = Date.now();
        jQuery.ajax({
            type: 'POST',
            url:  ajaxURL,
            data: {
                nonce:    ajaxNonce,
                action:   'cart_update_item',
                key:      key,
                quantity: quantity,
            },
            success: function ( response ) {
                withMinDelay( start, function () {
                    if ( response.success ) {
                        refreshCart( response.data );
                    } else {
                        clearLoading( key );
                    }
                });
            },
            error: function () {
                withMinDelay( start, function () {
                    clearLoading( key );
                });
            },
        });
    }

    function removeItem( key ) {
        setLoading( key );
        const start = Date.now();
        jQuery.ajax({
            type: 'POST',
            url:  ajaxURL,
            data: {
                nonce:  ajaxNonce,
                action: 'cart_remove_item',
                key:    key,
            },
            success: function ( response ) {
                withMinDelay( start, function () {
                    if ( ! response.success ) {
                        clearLoading( key );
                        return;
                    }
                    if ( response.data.is_empty ) {
                        window.location.href = response.data.redirect_url;
                        return;
                    }
                    refreshCart( response.data );
                });
            },
            error: function () {
                withMinDelay( start, function () {
                    clearLoading( key );
                });
            },
        });
    }

    $cart.on('click', '[data-action="qty_minus"]', function () {
        const key    = jQuery(this).data('key');
        const $input = $cart.find('[data-action="update_qty"][data-key="' + key + '"]');
        const newQty = Math.max( 1, parseInt( $input.val(), 10 ) - 1 );
        $input.val( newQty );
        updateItem( key, newQty );
    });

    $cart.on('click', '[data-action="qty_plus"]', function () {
        const key    = jQuery(this).data('key');
        const $input = $cart.find('[data-action="update_qty"][data-key="' + key + '"]');
        const newQty = parseInt( $input.val(), 10 ) + 1;
        $input.val( newQty );
        updateItem( key, newQty );
    });

    $cart.on('input', '[data-action="update_qty"]', function () {
        const key = jQuery(this).data('key');
        const qty = Math.max( 1, parseInt( jQuery(this).val(), 10 ) || 1 );
        clearTimeout( qtyTimer );
        qtyTimer = setTimeout( function () {
            updateItem( key, qty );
        }, 600 );
    });

    $cart.on('click', '[data-action="remove_item"]', function ( e ) {
        e.preventDefault();
        removeItem( jQuery(this).data('key') );
    });

}